module.exports = __webpack_public_path__ + "static/media/icon-popup-snow-footer.35b7a49e.png";